/**
 * Article JSON-LD helper. Used on statement/testimony/bishops-letter
 * detail pages so search engines index each piece of published record
 * as the Conference's own authoritative Article.
 *
 * The sitewide Organization block lives in public/index.html so it's
 * present in the raw HTML before React hydrates.
 */
import { useEffect } from "react";

export function ArticleJsonLd({ statement, canonicalUrl }) {
  useEffect(() => {
    if (!statement) return;
    const id = "ld-article";
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const data = {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": statement.title,
      "datePublished": statement.published_at,
      "dateModified": statement.updated_at || statement.published_at,
      "author": {
        "@type": "Organization",
        "name": statement.author || "Colorado Catholic Conference",
      },
      "publisher": {
        "@type": "Organization",
        "@id": "https://cocatholic.org/#organization",
        "name": "Colorado Catholic Conference",
        "logo": {
          "@type": "ImageObject",
          "url": "https://cocatholic.org/favicon.svg",
        },
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": canonicalUrl,
      },
      "description": statement.excerpt || undefined,
      "articleBody": statement.body || undefined,
      "inLanguage": statement._lang || "en",
    };

    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, [statement, canonicalUrl]);

  return null;
}
